export default __webpack_public_path__ + "0af1f43d2d45e2afd42e4ca5541e57f6.jpg";